<template>
  <v-container fluid grid-list-md>
    <v-layout column v-if="userProject">

      <v-flex xs12>
        <h6 class="title" v-if="userProject">Project: {{ userProject.title }} - Survey: {{ completedSurveys + 1 }} / {{ maxSurveysForUserProject }}</h6>
      </v-flex>
  
      <v-flex xs12 v-if="showError">
        <v-alert
        v-model="showError"
        type="error"
        icon="warning"
        dismissible>
          {{ errorMessage }}
        </v-alert>
      </v-flex>

      <v-flex xs12>
        <v-stepper
        v-model="stepNumber"
        vertical>
      
          <!-- <v-stepper-items> -->
          <v-stepper-step step="1" :complete="stepNumber > 1"><span class="color-give">Energy you give</span></v-stepper-step>
          <v-stepper-content step="1">
            <p class="title color-gray">How much energy do you give to <span class="color-give">{{ areas[areaIndex] }}</span>?</p>
            <p class="color-gray">{{ descriptions[areaIndex] }}</p>

            <v-layout :row="!isMobile" :column="isMobile">
              <v-flex grow>
                <SliderPointers v-model="resultValue" />
                <v-slider
                class="give"
                v-model="resultValue"
                min="0"
                max="10"
                thumb-color="primary"
                thumb-label="always"
                always-dirty
                color="primary"
                :disabled="isSavingAnswerToUserProject"
                ></v-slider>
                <v-layout row align-start justify-space-between font-weight-bold>
                  <v-flex shrink>
                    LOW ENERGY
                  </v-flex>
                  <v-flex shrink>
                    HIGH ENERGY
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex shrink align-self-center>
                <v-btn
                color="primary"
                @click="next"
                :disabled="isSavingAnswerToUserProject"
                >Next ({{ areaIndex + 1 }}/{{ areas.length }})</v-btn>
              </v-flex>
            </v-layout>
          </v-stepper-content>

          <v-stepper-step step="2" :complete="stepNumber > 2"><span class="color-receive">Energy you receive</span></v-stepper-step>
          <v-stepper-content step="2">
            <p class="title color-gray">How much energy do you receive from <span class="color-receive">{{ areas[areaIndex] }}</span>?</p>
            <p class="color-gray">{{ descriptions[areaIndex] }}</p>

            <v-layout :row="!isMobile" :column="isMobile">
              <v-flex grow>
                <SliderPointers v-model="resultValue" received />
                <v-slider
                class="receive"
                v-model="resultValue"
                min="0"
                max="10"
                thumb-color="secondary"
                thumb-label="always"
                always-dirty
                color="secondary"
                :disabled="isSavingAnswerToUserProject"
                ></v-slider>
                <v-layout row align-start justify-space-between font-weight-bold color-secondary>
                  <v-flex shrink>
                    LOW ENERGY
                  </v-flex>
                  <v-flex shrink>
                    HIGH ENERGY
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex shrink align-self-center>
                <v-btn
                color="primary"
                @click="next"
                :disabled="isSavingAnswerToUserProject"
                >Next ({{ areaIndex + 1 }}/{{ areas.length }})</v-btn>
              </v-flex>
            </v-layout>

          </v-stepper-content>

          <v-stepper-step step="3" :complete="stepNumber > 3">Personal data</v-stepper-step>
          <v-stepper-content step="3">

            <v-text-field
            label="Name and Surname"
            v-model="displayName"
            :error-messages="displayNameErrors"
            @input="$v.displayName.$touch()"
            @blur="$v.displayName.$touch()"
            required
            :disabled="isSavingAnswerToUserProject"
            ></v-text-field>

            <v-text-field
            label="Nickname"
            v-model="nickname"
            :error-messages="nicknameErrors"
            @input="$v.nickname.$touch()"
            @blur="$v.nickname.$touch()"
            required
            :disabled="isSavingAnswerToUserProject"
            ></v-text-field>

            <v-text-field
            label="E-mail"
            v-model="email"
            type="email"
            :error-messages="emailErrors"
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
            required
            :disabled="isSavingAnswerToUserProject"
            ></v-text-field>

            <v-radio-group
            label="Gender"
            v-model="gender"
            :error-messages="genderErrors"
            @input="$v.gender.$touch()"
            @blur="$v.gender.$touch()"
            required
            :disabled="isSavingAnswerToUserProject"
            >
              <v-layout row>
                <v-flex shrink>
                  <v-radio
                  key="m"
                  label="Male"
                  value="Male"
                  ></v-radio>
                </v-flex>
                <v-flex shrink>
                  <v-radio
                  key="f"
                  label="Female"
                  value="Female"
                  ></v-radio>
                </v-flex>
                <v-flex shrink>
                  <v-radio
                  key="o"
                  label="Undisclosed"
                  value="Undisclosed"
                  ></v-radio>
                </v-flex>
              </v-layout>
            </v-radio-group>

            <v-select
            :items="yearsOfBirth"
            label="Year of birth"
            v-model="yearOfBirth"
            :error-messages="yearOfBirthErrors"
            @input="$v.yearOfBirth.$touch()"
            @blur="$v.yearOfBirth.$touch()"
            required
            :disabled="isSavingAnswerToUserProject"
            ></v-select>

            <v-text-field
            label="Education"
            v-model="education"
            :error-messages="educationErrors"
            @input="$v.education.$touch()"
            @blur="$v.education.$touch()"
            required
            :disabled="isSavingAnswerToUserProject"
            ></v-text-field>

            <v-text-field
            label="Position in the company"
            v-model="position"
            :disabled="isSavingAnswerToUserProject"
            ></v-text-field>

            <v-btn
            color="primary"
            @click="validateForm"
            :disabled="isSavingAnswerToUserProject"
            >Confirm</v-btn>

          </v-stepper-content>
          <!-- </v-stepper-items> -->
        </v-stepper>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations, mapActions } from 'vuex'
// import { firebase } from '@/firebase.js';
// import { auth, firestore, db } from '@/firebase.js';
import _ from 'lodash'
import moment from 'moment'
import icabody from '@/icabody.js'
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  // minLength
  // maxLength
} from 'vuelidate/lib/validators'
import SliderPointers from '@/components/SliderPointers'

export default {
  name: 'Survey',

  mixins: [ validationMixin ],

  components: {
    SliderPointers
  },

  data: () => ({
    debug: false,

    showError: false,
    errorMessage: '',

    maxSurveysForUserProject: icabody.getMaxSurveysForUserProject(),

    // giveReceiveText: '',
    surveyIndex: 0,
    stepNumber: 1,
    areaIndex: 0,
    defaultResultValue: 5,
    resultValue: 5,
    areas: icabody.getSurveyAreas(),
    descriptions: icabody.getDescriptionAreas(),
    // areas: [
    //   'spiritual life',
    //   'cultural update',
    //   'professional update',
    //   'social life and friends',
    //   'work',
    //   'children',
    //   'love',
    //   'body and health care',
    //   'sexual life',
    //   'food',
    //   'sleep',
    //   'home',
    //   'family of origin',
    //   'financial stability'
    // ],

    displayName: null,
    nickname: null,
    email: null,
    gender: null,
    yearOfBirth: null,
    yearsOfBirth: [],
    education: null,
    position: null
  }),

  validations: {
    displayName: { required },
    nickname: { required },
    email: { required, email },
    gender: { required },
    yearOfBirth: { required },
    education: { required }
  },

  props: {},

  computed: {
    ...mapState('auth', {
      user: state => state.user // map `this.user` to `this.$store.state.user.auth.user`
    }),

    ...mapState('usersProjects', {
      userProject: state => state.userProject, // map `this.userProject` to `this.$store.state.userProject`
      isSavingAnswerToUserProject: state => state.isSavingAnswerToUserProject // map `this.isSavingAnswerToUserProject` to `this.$store.state.isSavingAnswerToUserProject`
    }),

    ...mapState('util', {
      isMobile: state => state.isMobile // map `this.isMobile` to `this.$store.state.util.isMobile`
    }),

    displayNameErrors() {
      const errors = [];
      if (this.$v.displayName.$dirty) {
        !this.$v.displayName.required && errors.push('Field required');
      }
      return errors;
    },
    nicknameErrors() {
      const errors = [];
      if (this.$v.nickname.$dirty) {
        !this.$v.nickname.required && errors.push('Field required');
      }
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (this.$v.email.$dirty) {
        !this.$v.email.email && errors.push('Must be valid e-mail');
        !this.$v.email.required && errors.push('Field required');
      }
      return errors;
    },
    genderErrors() {
      const errors = [];
      if (this.$v.gender.$dirty) {
        !this.$v.gender.required && errors.push('Field required');
      }
      return errors;
    },
    yearOfBirthErrors() {
      const errors = [];
      if (this.$v.yearOfBirth.$dirty) {
        !this.$v.yearOfBirth.required && errors.push('Field required');
      }
      return errors;
    },
    educationErrors() {
      const errors = [];
      if (this.$v.education.$dirty) {
        !this.$v.education.required && errors.push('Field required');
      }
      return errors;
    },

    completedSurveys () {
      let completedSurveys = 0
      if (this.userProject || this.userProject.surveys) {
        this.userProject.surveys.forEach((survey) => {
          if (survey.completed) {
            completedSurveys ++
          }
        })
      }
      return completedSurveys
    }
  },

  watch: {
    userProject: function (userProject) {
      if (this.debug) console.log(this.$options.name+'.watch userProject:',userProject,'this.userProject['+(typeof this.userProject)+']:',this.userProject);
      this.updateSurvey()
    }
  },

  created () {
    if (this.debug) console.log(this.$options.name+'.created() userProject:',this.userProject)
    if (this.debug) console.log(this.$options.name+'.created()');
    this.yearsOfBirth = this.getYearsOfBirth()
    // if userProject is not set (from a direct link) reload all userProjects
    if (!this.userProject) {
      // read userProjects from the db and store
      this.readMyUserProjects()
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.created() readed $route.params.id:',this.$route.params.id)
        this.showError = false
        return this.setUserProjectById(this.$route.params.id)
      })
      .catch((error) => {
        this.errorMessage = error.message
        this.showError = true
      })
    }
    this.updateSurvey()
  },

  methods: {
    ...mapMutations('usersProjects', [
      'setUserProjectById' // map `this.setUserProjectById()` to `this.$store.commit('usersProjects/setUserProjectById')`
    ]),

    ...mapActions('usersProjects', [
      'readMyUserProjects', // map `this.readMyUserProjects()` to `this.$store.dispatch('usersProjects/readMyUserProjects')`
      'saveAnswerToUserProject' // map `this.saveAnswerToUserProject()` to `this.$store.dispatch('usersProjects/saveAnswerToUserProject')`
    ]),

    updateSurvey () {
      if (!this.userProject) return
      let surveys = this.userProject.surveys
      if (_.isArray(surveys) && surveys.length >= icabody.getMaxSurveysForUserProject() && surveys[2].completed) {
        // reached the max number of suvey for this project
        if (this.debug) console.warn(this.$options.name+'.watch userProject. Reached the max number of suvey for this project!')
        this.$router.push('/project/'+this.userProject.projectId)
      }
      let surveyIndex = 0
      // get current surveyIndex
      surveys.forEach((survey, index) => {
        if (survey.completed) {
          surveyIndex = index + 1
        }
      })
      this.surveyIndex = surveyIndex
      // set stepNumber and areaIndex according to not completed userProject
      let newStepNumber = this.stepNumber
      let newAreaIndex = this.areaIndex
      if (surveys[this.surveyIndex] && surveys[this.surveyIndex].answers) {
        surveys[this.surveyIndex].answers.forEach((element, index) => {
          if (this.debug) console.log(this.$options.name+'.updateSurvey() --- index:',index,'element:',element)
          if ('received' in element) {
            newStepNumber = 2
            newAreaIndex = index + 1
          }
          else if (newStepNumber == 1 && 'given' in element) {
            newAreaIndex = index + 1
          }
        })
        if (this.debug) console.log(this.$options.name+'.updateSurvey() --- newStepNumber:',newStepNumber,'newAreaIndex:',newAreaIndex,'surveys[this.surveyIndex].answers.length:',surveys[this.surveyIndex].answers.length)
        if (newAreaIndex === surveys[this.surveyIndex].answers.length) {
          newStepNumber = newStepNumber + 1
          newAreaIndex = 0
        }
      }
      this.stepNumber = newStepNumber
      this.areaIndex = newAreaIndex
      if (this.debug) console.log(this.$options.name+'.updateSurvey() --- newStepNumber:',newStepNumber,'newAreaIndex:',newAreaIndex)
      this.resetForm()
    },

    onInput (arg) {
      if (this.debug) console.log(this.$options.name+'.onInput() arg:',arg)
    },

    resetForm() {
      this.$v.$reset()
      this.displayName = this.user.displayName
      this.nickname = this.user.nickname
      this.email = this.user.email
      this.gender = this.user.gender
      this.yearOfBirth = this.user.yearOfBirth
      this.education = this.user.education
      this.position = this.user.position
    },

    validateForm() {
      if (this.debug) console.log(this.$options.name+'.validateForm()')
      if (this.debug) console.log(this.$options.name+'.validateForm() this.gender:',this.gender)
      if (this.debug) console.log(this.$options.name+'.validateForm() $v.$invalid:',this.$v.$invalid)
      if (this.debug) console.log(this.$options.name+'.validateForm() $v.displayName:',this.$v.displayName)
      if (this.debug) console.log(this.$options.name+'.validateForm() $v.nickname:',this.$v.nickname)
      if (this.debug) console.log(this.$options.name+'.validateForm() $v.email:',this.$v.email)
      if (this.debug) console.log(this.$options.name+'.validateForm() $v.gender:',this.$v.gender)
      if (this.debug) console.log(this.$options.name+'.validateForm() $v.yearOfBirth:',this.$v.yearOfBirth)
      if (this.debug) console.log(this.$options.name+'.validateForm() $v.education:',this.$v.education)
      if (this.debug) console.log(this.$options.name+'.validateForm() $v.position:',this.$v.position)
      // if (this.debug) console.log(this.$options.name+'.validateForm() $v.education.$dirty:',this.$v.education.$dirty)
      // if (this.debug) console.log(this.$options.name+'.validateForm() $v.education.$invalid:',this.$v.education.$invalid)
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.debug) console.log(this.$options.name+'.validateForm()')
        this.next()
      }
    },

    next () {
      if (this.debug) console.log(this.$options.name+'.next() stepNumber:',this.stepNumber)
      let answerData = {
        step: this.stepNumber,
        areaIndex: this.areaIndex,
        value: this.resultValue
      }
      if (this.stepNumber === 3) {
        answerData = {
          step: this.stepNumber,
          // areaIndex: 0,
          // value: 0,
          displayName: this.displayName,
          nickname: this.nickname,
          email: this.email,
          gender: this.gender,
          yearOfBirth: this.yearOfBirth,
          education: this.education,
          position: this.position
        }
      }
      this.saveAnswerToUserProject(answerData)
      .then(() => {
        if (this.stepNumber == 3) {
          this.stepNumber++
          // TODO: mettere un testo di notifica di fine survey
          this.$router.push('/project/'+this.userProject.projectId);
        }
        else {
          this.areaIndex++
          this.resultValue = this.defaultResultValue
          if (this.areaIndex === this.areas.length) {
            this.areaIndex = 0
            this.stepNumber++
          }
        }
        if (this.debug) console.log(this.$options.name+'.next() areaIndex:',this.areaIndex)
        this.showError = false
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.addProject() error:',error)
        this.errorMessage = error
        this.showError = true
      })
    },

    getYearsOfBirth () {
      let years = []
      let year = moment().year()
      let firstYear = year - 120
      // eslint-disable-next-line for-direction
      for (; year > firstYear; year--) {
        years.push(year)
      }
      return years
    }
  }
}
</script>

<style> /* "scoped" attribute limit the CSS to this component only */
.v-input--slider {
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 36px !important;
}
/*
@media screen and (max-width: 768px) {
  .v-input--slider {
    margin-left: 12px;
    margin-right: 12px;
  }
}
*/
.v-text-field.center-text,
.v-text-field.center-text input {
  text-align: center;
}
.v-input--slider.give .v-slider__thumb-label {
  color: #0B3B5E;
}
.v-input--slider.receive .v-slider__thumb-label {
  color: #FF2A52;
}
/*
.sliderPointerPosition {
  position: relative;
}
.sliderPointerPosition > div {
  position: absolute;
  width: 100%;
  top: 50px;
  padding-left: 28px;
  padding-right: 28px;
}
.sliderPointerContainer {
  margin: 0 !important;
}
.sliderPointerContainer > .flex {
  height: 20px;
  border: 1px solid black;
}
.flexGrow1 {
  flex-grow: 1;
}
.flexGrow2 {
  flex-grow: 2;
}
.colorGiven0 {
  background-color: rgba(11,59,94,0.0);
}
.colorGiven1 {
  background-color: rgba(11,59,94,0.1);
}
.colorGiven2 {
  background-color: rgba(11,59,94,0.2);
}
.colorGiven3 {
  background-color: rgba(11,59,94,0.3);
}
.colorGiven4 {
  background-color: rgba(11,59,94,0.4);
}
.colorGiven5 {
  background-color: rgba(11,59,94,0.5);
}
.colorGiven6 {
  background-color: rgba(11,59,94,0.6);
}
.colorGiven7 {
  background-color: rgba(11,59,94,0.7);
}
.colorGiven8 {
  background-color: rgba(11,59,94,0.8);
}
.colorGiven9 {
  background-color: rgba(11,59,94,0.9);
}
.colorGiven10 {
  background-color: rgba(11,59,94,1.0);
}
*/
</style>